import React from 'react';
import {
  AdminSection,
  CoursesListItemStyle,
  LastMaterialLink,
} from '../Styles/Styles';
import { H2 } from '../../../__core/Styles/Headings/Headings';
import { arrowIcon } from './Arrow';
import { ICourseInstance } from '../../../__core/Interfaces/ICourseInstance';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import AppConfig from '../../../Configs/AppConfig';
import { havePermissions } from '../../../__core/Providers/Permissions/Permissions';
import ROLES from '../../../__core/Enums/Roles';
import { settingsIcon } from '../../../Assets/images/settings';
import { FlagLabel } from '../../../__core/Styles/FlagLabel/FlagLabelStyle';

type CourseItemProps = {
  course: ICourseInstance;
};

const CourseItem: React.FunctionComponent<CourseItemProps> = ({
  course,
}): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <CoursesListItemStyle
      key={course.id}
      as={NavLink}
      to={`/course/${course.signature}`}
    >
      {course.selfRegister && <FlagLabel>{t('Free course')}</FlagLabel>}
      {course.icon && (
        <div className="course-icon">
          <img
            src={AppConfig.COURSE_ICON_BASE_URL + course.icon}
            alt="course logo"
          />
        </div>
      )}
      <div className="course-description">
        <div className="title-section">
          <H2 id={`nav-to-course-${course.id}`}>{course.product.name}</H2>
        </div>
        <div className="semi-title">
          {t('Signature')}: {course.signature}
        </div>
        <p>{course.description}</p>

        <div className="additional-info">
          <div className="additional-info-labels">
            {course.mentor && <div>{t('Mentor')}:</div>}
            {course.cs && <div>{t('Course Specialist')}:</div>}
            {course.currentMaterial && <div>{t('Current')}:</div>}
          </div>

          <div className="additional-info-data">
            {course.mentor && <div>{course.mentor.name}</div>}
            {course.cs && <div>{course.cs.name}</div>}
            {course.currentMaterial &&
              havePermissions([ROLES.ROLE_USER], course.roles) && (
                <div>
                  {course.currentMaterial.name} &nbsp;
                  <LastMaterialLink>
                    <NavLink
                      to={`/material/${course.id}/${course.currentMaterial.chapterId}/${course.currentMaterial.id}`}
                    >
                      {arrowIcon}
                    </NavLink>
                  </LastMaterialLink>
                </div>
              )}
          </div>
        </div>
        {havePermissions([ROLES.ROLE_CS, ROLES.ROLE_MENTOR], course.roles) && (
          <AdminSection>
            <Link to={`/course-instance/${course.signature}/Sharing`}>
              {t('Sharing')} & {t('Gradebook')} {settingsIcon}
            </Link>
          </AdminSection>
        )}
      </div>
    </CoursesListItemStyle>
  );
};

export default CourseItem;
